import { Directive, TemplateRef, inject, input } from '@angular/core';

@Directive({
    selector: '[ntvTableCell]',
    standalone: true,
})
export class NtvTableCellDirective {
    // signal input
    public columnName = input.required<string>({
        alias: 'ntvTableCell',
    });

    // inject instead of constructor
    public template = inject<TemplateRef<any>>(TemplateRef);
}
